import { MARCUS_ONBOARDING_NEXT_TARGET as NEXT_TARGET } from "./MarcusOnboardingSpotlight";

export const LAST_EXPLORE_TARGET = "explore-card-meta-campaigns";
export const STATIC_ADS_ENTRY_TARGET = "static-ads-new-ad";
export const STATIC_ADS_CLONE_TARGET = "static-ads-clone";
export const STATIC_ADS_FORMATS_TARGET = "static-ads-trending";
export const STATIC_ADCLONE_DISCOVER_TARGET = "static-adclone-discover-tab";
export const STATIC_ADCLONE_PRODUCT_PICKER_TARGET = "static-adclone-product-picker-add";
export const STATIC_ADCLONE_PRODUCT_IMAGE_TARGET = "static-adclone-product-image-upload";
export const STATIC_ADCLONE_PRODUCT_AI_ADD_TARGET = "static-adclone-product-ai-add";
export const STATIC_ADCLONE_DISCOVER_BUTTON_TARGET = "static-adclone-discover-button";
export const STATIC_ADCLONE_DISCOVERED_ADS_TARGET = "static-adclone-discovered-ads";
export const VIDEO_ADS_ENTRY_TARGET = "video-ads-new-ad";
export const VIDEO_ADS_CLONE_TARGET = "video-ads-clone";
export const VIDEO_ADS_UGC_TARGET = "video-ads-ugc";
export const VIDEO_ADS_TEMPLATES_TARGET = "video-ads-trending";
export const META_AGENT_TASKS_TARGET = "meta-agent-tasks-tab";
export const ADS_AGENT_SIDE_PANEL_TARGET = "ads-agent-side-panel";
export const COMPANION_AGENT_LIST_TARGET = "companion-agent-list";
export const COMPANION_AGENT_LIST_TEAM_SWEEP_TARGET = "companion-agent-list-team-sweep";
export const LAST_AGENT_ROW_TARGET = "companion-agent-row-meta_ads";
// Keeps the first gate close to Marcus's spoken CTA while leaving
// a short beat on the final Explore card.
export const EXPLORE_NEXT_GATE_REVEAL_MS = 3000;

const COMPANION_AGENT_ROW_TARGETS = [
  "companion-agent-row-marcus",
  "companion-agent-row-banan",
  "companion-agent-row-vid",
  "companion-agent-row-scout",
  "companion-agent-row-gads",
  LAST_AGENT_ROW_TARGET,
] as const;

export const ONBOARDING_FINAL_STEP_COPY =
  "With creatives covered, let's click 'Next step' to see how Mads turns winners into managed spend.";
export const ONBOARDING_STATIC_ADS_STEP_REPLY =
  "Static Ads turns proven concepts and formats into sales-ready tests fast. Now that we've seen static formats, let's click 'Next step' to explore Video Ads.";
export const ONBOARDING_VIDEO_ADS_STEP_REPLY =
  `Video Ads gives you Adclone, tailored UGC, and proven templates for fast performance tests. ${ONBOARDING_FINAL_STEP_COPY}`;
export const ONBOARDING_AGENT_LIST_STEP_COPY =
  "To make this all happen, let's click 'Next step' to meet the specialist agents.";
export const ONBOARDING_STATIC_CLONE_NEXT_STEP_COPY =
  "Now that you've met the team, let's click 'Next step' to try a quick static ad clone.";
export const ONBOARDING_QUICK_STATIC_ADCLONE_COPY =
  "To make it concrete, let's try a quick static ad clone with your product.";
export const ONBOARDING_STATIC_ADCLONE_ADD_PRODUCT_COPY =
  "You can add a new product to start discovering similar ads for it in Meta.";
export const ONBOARDING_STATIC_ADCLONE_UPLOAD_IMAGE_COPY =
  "Simply add an image here — we'll extract the product details and run relevant searches for it.";
export const ONBOARDING_STATIC_ADCLONE_AI_ADD_COPY =
  "Now click Add Product so Gemini can extract the catalog details from the image.";
export const ONBOARDING_STATIC_ADCLONE_SEARCH_COPY =
  "Now click Search Again to start pulling proven Meta ads for this product.";
export const ONBOARDING_STATIC_ADCLONE_DISCOVERING_COPY =
  "Our agents are now discovering proven ads for your product...";
export const ONBOARDING_STATIC_ADCLONE_PICK_AD_COPY =
  "Once the running ads show up, pick one and we'll start the cloning process from there.";
export const ONBOARDING_FINISH_STEP_COPY =
  "Just one last step wraps up the tour.";
export const ONBOARDING_AGENT_LIST_TEAM_SWEEP_COPY =
  "Each agent spawns here as you start a related task. Specialist chats stay hidden until that task activates them, then you can open the agent here to refine creatives or tune campaigns.";

export const ONBOARDING_HIGHLIGHT_LABELS: Record<string, string> = {
  "explore-card-image-ads": "Static Ads",
  "explore-card-video-ads": "Video Ads",
  "explore-card-meta-campaigns": "Meta & Google Ads",
  "sidebar-nav-static-ads": "Static Ads",
  "sidebar-nav-video-ads": "Video Ads",
  "sidebar-nav-meta-campaigns": "Meta & Google Ads",
  [STATIC_ADS_ENTRY_TARGET]: "New Static Ad",
  [STATIC_ADS_CLONE_TARGET]: "Clone Winning Image Ads",
  [STATIC_ADS_FORMATS_TARGET]: "Use Proven Formats",
  [STATIC_ADCLONE_DISCOVER_TARGET]: "Discover by Product",
  [STATIC_ADCLONE_PRODUCT_PICKER_TARGET]: "Add a New Product",
  [STATIC_ADCLONE_PRODUCT_IMAGE_TARGET]: "Add Product Image",
  [STATIC_ADCLONE_PRODUCT_AI_ADD_TARGET]: "Add Product",
  [STATIC_ADCLONE_DISCOVER_BUTTON_TARGET]: "Search Again",
  [STATIC_ADCLONE_DISCOVERED_ADS_TARGET]: "Running Ads",
  [VIDEO_ADS_ENTRY_TARGET]: "New Video Ad",
  [VIDEO_ADS_CLONE_TARGET]: "Clone Winning Ads",
  [VIDEO_ADS_UGC_TARGET]: "Custom UGC Videos",
  [VIDEO_ADS_TEMPLATES_TARGET]: "Use Proven Templates",
  [META_AGENT_TASKS_TARGET]: "Agent Tasks",
  [ADS_AGENT_SIDE_PANEL_TARGET]: "Agent Side Panel",
  [COMPANION_AGENT_LIST_TARGET]: "Agent List",
  [COMPANION_AGENT_LIST_TEAM_SWEEP_TARGET]: "Your Agent Team",
  "companion-agent-row-marcus": "Marcus",
  "companion-agent-row-banan": "Agent Banan",
  "companion-agent-row-vid": "Agent Vid",
  "companion-agent-row-agent_v": "Agent V",
  "companion-agent-row-scout": "Agent Scout",
  "companion-agent-row-gads": "Agent G",
  [LAST_AGENT_ROW_TARGET]: "Agent Mads",
};

export const ONBOARDING_TARGETS = new Set([
  "explore-card-image-ads",
  "explore-card-video-ads",
  "explore-card-meta-campaigns",
  "sidebar-nav-static-ads",
  "sidebar-nav-video-ads",
  "sidebar-nav-meta-campaigns",
  NEXT_TARGET,
  STATIC_ADS_ENTRY_TARGET,
  STATIC_ADS_CLONE_TARGET,
  STATIC_ADS_FORMATS_TARGET,
  STATIC_ADCLONE_DISCOVER_TARGET,
  STATIC_ADCLONE_PRODUCT_PICKER_TARGET,
  STATIC_ADCLONE_PRODUCT_IMAGE_TARGET,
  STATIC_ADCLONE_PRODUCT_AI_ADD_TARGET,
  STATIC_ADCLONE_DISCOVER_BUTTON_TARGET,
  STATIC_ADCLONE_DISCOVERED_ADS_TARGET,
  VIDEO_ADS_ENTRY_TARGET,
  VIDEO_ADS_CLONE_TARGET,
  VIDEO_ADS_UGC_TARGET,
  VIDEO_ADS_TEMPLATES_TARGET,
  META_AGENT_TASKS_TARGET,
  ADS_AGENT_SIDE_PANEL_TARGET,
  COMPANION_AGENT_LIST_TARGET,
  COMPANION_AGENT_LIST_TEAM_SWEEP_TARGET,
  ...COMPANION_AGENT_ROW_TARGETS,
]);

export const LONG_SPOTLIGHT_TARGETS = new Set([
  "explore-card-image-ads",
  "explore-card-video-ads",
  LAST_EXPLORE_TARGET,
  STATIC_ADS_CLONE_TARGET,
  STATIC_ADS_FORMATS_TARGET,
  VIDEO_ADS_CLONE_TARGET,
  VIDEO_ADS_UGC_TARGET,
  VIDEO_ADS_TEMPLATES_TARGET,
  STATIC_ADCLONE_PRODUCT_IMAGE_TARGET,
  STATIC_ADCLONE_PRODUCT_AI_ADD_TARGET,
  STATIC_ADCLONE_DISCOVERED_ADS_TARGET,
  COMPANION_AGENT_LIST_TEAM_SWEEP_TARGET,
]);

export const STAGE_GATE_REVEAL_TARGETS = new Set([
  STATIC_ADS_FORMATS_TARGET,
  VIDEO_ADS_TEMPLATES_TARGET,
  META_AGENT_TASKS_TARGET,
  STATIC_ADCLONE_DISCOVERED_ADS_TARGET,
  ADS_AGENT_SIDE_PANEL_TARGET,
  COMPANION_AGENT_LIST_TEAM_SWEEP_TARGET,
]);
